import styled, { css } from 'styled-components';

import { colors, typography, spacing } from '../../../../styles/theme';

export const Table = styled.table`
  width: 100%;
  text-align: left;
  box-sizing: border-box;
  font-size: 16px;
  margin-bottom: ${spacing('10')};

  tr {
    border-bottom: 1px solid ${colors('black.08')};
  }

  th {
    font-weight: ${typography('weights.semibold')};
  }

  td,
  th {
    padding: ${spacing('small')} ${spacing('small')};
    vertical-align: middle;
  }
`;

interface StatusProps {
  status?: 'dispensed' | 'canceled-dispensation';
}

export const Status = styled.td<StatusProps>`
  color: ${colors('accent.base')};

  ${({ status }: StatusProps) =>
    status === 'canceled-dispensation' &&
    css`
      color: #d22;
    `}
`;
